import Dashboard from "pages/dashboard";
import UserManagement from "pages/user-management/UserManagement";
import CategoryManagement from "pages/surveyCategory/SurveyCategory";
import FAQManagement from "pages/faq/faq";
import ContentManagement from "pages/content-management/ContentManagement";
import UserDetail from "pages/user-management/view/UserDetail";
import HelpAndSupport from "pages/helpSupport/HelpAndSupport";
import GroupManagement from "pages/group-management";
import GroupDetail from "pages/group-management/GroupDetail";
import FeedbackManag from "pages/feedback_management/FeedbackManag";
import SubAdminList from "pages/sub-admin_management/SubAdminList";
import ActivityManagement from "pages/activity/ActivityManagement";
import BabiesDetails from "pages/user-management/view/BabiesDetails";
import ArticleManagement from "pages/article";
import RecipeManagement from "pages/recipe";
import SubscriptionManagement from "pages/subscription";
import ReportManagement from "pages/report-management";
import ReportDetail from "pages/report-management/UserDetail";

export const routes = () => {
  const allRoutes = [
    // Dashboard
    {
      id: 101,
      enabled: true,
      path: "/dashboard",
      element: <Dashboard />,
    },
    // User
    {
      id: 102,
      enabled: true,
      element: <UserManagement />,
      path: "/user-management",
    },

    {
      id: 106,
      enabled: true,
      element: <UserDetail />,
      path: "/user-management/user-detail/:userId",
    },
    {
      id: 106,
      enabled: true,
      element: <BabiesDetails />,
      path: "/user-management/baby-detail/:babyId",
    },
    // Group
    {
      id: 102,
      enabled: true,
      element: <GroupManagement />,
      path: "/group-management",
    },
    {
      id: 103,
      enabled: true,
      // element:<PersonalDetails/> ,
      element: <SubAdminList />,

      path: "/personal-details",
    },
    {
      id: 106,
      enabled: true,
      element: <GroupDetail />,
      path: "/group-management/user-detail/:userId",
    },


    // Survey Category
    {
      id: 103,
      enabled: true,
      element: <CategoryManagement />,
      path: "/survey-category",
    },

    // Faq
    {
      id: 104,
      enabled: true,
      element: <FAQManagement />,
      path: "/faq-management",
    },

    //CMS
    {
      id: 105,
      enabled: true,
      element: <ContentManagement />,
      path: "/content-management",
    },
    // Help and support
    {
      id: 107,
      enabled: true,
      element: <HelpAndSupport />,
      path: "/help-support",
    },
    // FeedBack_Management

    {
      id: 108,
      enabled: true,
      element: <FeedbackManag />,
      path: "/feedback-management",
    },
    {
      id: 109,
      enabled: true,
      element: <ActivityManagement />,
      path: "/activity-management",
    },
    {
      id: 110,
      enabled: true,
      element: <ArticleManagement />,
      path: "/article-management",
    },
    {
      id: 111,
      enabled: true,
      element: <RecipeManagement />,
      path: "/recipe-management",
    },
    {
      id: 112,
      enabled: true,
      element: <SubscriptionManagement />,
      path: "/subscription-management",
    },
    // Report
    {
      id: 113,
      enabled: true,
      element: <ReportManagement />,
      path: "/report-management",
    },
    {
      id: 114,
      enabled: true,
      element: <ReportDetail />,
      path: "/report-management/user-detail/:userId",
    },
  ].filter((data) => data.enabled);
  return allRoutes;
};
